module.exports = __webpack_public_path__ + "img/player_not_found.9ddfeefa.png";